export enum MessageType{
    alert,
    toast,
    popup,
    image
}